<template lang="pug">
menu-bar.menu-bar
  HscMapMenu
  ModuleOutlet(module="tool", type="toolMenu", v-if="!jupyter")
  ViewMenu
  FrameMenu(v-if="!jupyter")
  DatasetMenu
  ModuleOutlet(module="bookmark", type="bookmarkMenu", v-if="!jupyter")
  ModuleOutlet(module="background", type="backgroundMenu", v-if="!jupyter")
  AnalysisMenu
</template>


<script lang="ts">
import { Vue, Component } from "vue-property-decorator";
import HscMapMenu from "./HscMapMenu.vue";
import ViewMenu from "./ViewMenu/index.vue";
import FrameMenu from "./FrameMenu/index.vue";
import DatasetMenu from './DatasetMenu/index.vue'
import AnalysisMenu from './AnalysisMenu/index.vue'
import { queryParams } from '../../../utils/query_params';

@Component({
  components: {
    HscMapMenu,
    ViewMenu,
    FrameMenu,
    DatasetMenu,
    AnalysisMenu,
  },
})
export default class extends Vue {
  get jupyter() {
    return queryParams.jupyter
  }
}
</script>


<style lang="scss" scoped>
.menu-bar {
  border-radius: 0 0 4pt 0;
}
</style>